import { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants';
import authService from './AuthorizeService';

const AuthorizeRoute = (props) => {
	const [state, setState] = useState({
		ready: false,
		authenticated: false,
	});

	const checkAuthentication = async () => {
		let isAuthenticated = await authService.isAuthenticated();

		if (authenticated && !isAuthenticated)
			setState({ ready: true, authenticated: isAuthenticated });
	};

	const populateAuthenticationState = async () => {
		const authenticated = await authService.isAuthenticated();
		setState({ ready: true, authenticated });
	};

	const authenticationChanged = async () => {
		setState({ ready: false, authenticated: false });
		await populateAuthenticationState();
	};

	useEffect(() => {
		const subscription = authService.subscribe(() => authenticationChanged());
		populateAuthenticationState();

		// Cleanup function (equivalent to componentWillUnmount)
		return () => {
			authService.unsubscribe(subscription);
		};
	}, []); // Empty dependency array means this effect runs once on mount

	const { ready, authenticated } = state;

	const link = document.createElement('a');
	link.href = props.path;

	const returnUrl = `${link.protocol}//${link.host}${props.location.pathname}${link.search
		}${link.hash}`;

	const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl
		}=${encodeURIComponent(returnUrl)}`;

	if (!ready) {
		return <div></div>;
	}

	checkAuthentication();

	const { component: Component, ...rest } = props;

	return (
		<Route
			{...rest}
			render={(props) => {
				if (authenticated) {
					return <Component {...props} />;
				} else {
					return <Redirect to={redirectUrl} />;
				}
			}}
		/>
	);
};

export default AuthorizeRoute;
